import { GripVertical } from 'lucide-react';
import { useCallback, useMemo } from 'react';
import { Popup } from 'semantic-ui-react';
import { useConfidencesMap, useSetHighlightedMappingsMap } from '../../../../stores/mappingStore';
import { HighlightedMappingMapType, ImportTableDescriptorType, RowMappingType } from '../../../../types';
import MappingsAlternativesIndication from '../mappingsAlternativesIndication';
import './styles.css';
import { ROW_MAPPING_TARGET, ROW_MAPPING_TYPE } from '../../../../constants/generalConstants';

type ImportDescriptorPropsType = {
    mapping: RowMappingType;
    importDescriptor: ImportTableDescriptorType;
};

function ImportDescriptor({ mapping, importDescriptor }: ImportDescriptorPropsType) {
    const confidencesMap = useConfidencesMap();
    const setHighlightedMappingsMap = useSetHighlightedMappingsMap();

    const hasAlternativeMappings = useMemo(
        () =>
            !!mapping.alternatives.filter(
                (alm) => alm.target !== ROW_MAPPING_TARGET.SELF && alm.type !== ROW_MAPPING_TYPE.INITIAL
            ).length,
        [mapping.alternatives]
    );

    const highlightAlternatives = useCallback(() => {
        const alternativesMap = mapping.alternatives.reduce((acc, curr) => {
            acc[curr.descriptorId] = confidencesMap[mapping.rowId]?.[curr.descriptorId] ?? 0;
            return acc;
        }, {} as HighlightedMappingMapType);
        alternativesMap[mapping.rowId] = mapping.confidence;
        setHighlightedMappingsMap(alternativesMap);
    }, [mapping.alternatives, confidencesMap, setHighlightedMappingsMap]);

    return (
        <Popup
            pinned
            on={'click'}
            content={
                <div>
                    Row Id: {mapping.rowId} Confidence:{mapping.confidence}
                </div>
            }
            trigger={
                <div className="import-descriptor__content">
                    <GripVertical className="grip-icon" />
                    {importDescriptor.label}
                    {hasAlternativeMappings && (
                        <MappingsAlternativesIndication
                            highlightAlternatives={highlightAlternatives}
                            unhighlightAlternatives={() => {
                                setHighlightedMappingsMap({});
                            }}
                        />
                    )}
                </div>
            }
        />
    );
}

export default ImportDescriptor;
